import * as TYPE from "../types";
import axios from "axios";
import { api } from "../static";
import { toast } from "react-toastify";

export function getPermissionsData(params, headers, pageSize) {
  return (dispatch) => {
    axios
      .get(process.env.BASE_URL + api.permissionsData, {
        headers: headers,
        params: params,
      })
      .then((res) => {
        console.log("permissions get", res.data.data.permissions);
        let temp = Math.ceil(res.data.data.totalCount / pageSize);
        dispatch({
          type: TYPE.PERMISSIONS_DATA_FOUND,
          payload: {
            data: res.data.data.permissions,
            count: res.data.data.totalCount,
            totalPages: temp,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: TYPE.PERMISSIONS_DATA_ERROR,
          payload: err?.response,
        });
      });
  };
}

export function addNewPermission(
  headers,
  closeModal,
  setSearchFlag,
  permissionName
) {
  return (dispatch) => {
    axios
      .post(
        process.env.BASE_URL + api.addPermission,
        { name: permissionName },
        {
          headers: headers,
        }
      )
      .then((res) => {
        dispatch({ type: TYPE.NEW_PERMISSION_ADD_SUCCESS });
        closeModal();
        setSearchFlag((searchFlag) => !searchFlag);
        toast.success("Permission Created", {
          position: "top-center",
          autoClose: 1500,
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Operation failed, please reach out to dev team.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1500,
        });
        console.log(err);
      });
  };
}
